import React, { useContext, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DeleteOutlined, EditOutlined, VpnKeyOutlined } from '@mui/icons-material';
import { AuthContext } from '../../contexts/AuthContext';
import { PermissionsForm } from './PermissionsForm';
import { UpdateUserForm } from './UpdateUserForm';
import { CustomWarningDelete } from '../CustomWarningDelete';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import { useModalStore } from '../../store/useModalStore';

export const Actions = ({ data, permissions, updated, deleted }) => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    const { openModal: openModals } = useModalStore();

    const actions = useMemo(() => {
        return permisos?.find(p => p?.name === 'usuarios')?.actions?.filter(a => a?.name !== 'crear')?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    const openModal = (form) => openModals(form);

    const buttons = [
        { icon: <VpnKeyOutlined color='action' fontSize='small' />, action: () => openModal(<PermissionsForm data={ data } action={ (fields) => permissions(fields, data?.uid) } />) },
        { icon: <EditOutlined color='action' fontSize='small' />, action: () => openModal(<UpdateUserForm data={ data } action={ (fields) => updated(fields, data?.uid) } />)  },
        { icon: <DeleteOutlined color='action' fontSize='small' />, action: () => openModal(<CustomWarningDelete action={ () => deleted(data?.uid) } />) }
    ];

    return (
        <>
            { actions?.map((a, i) => a && (
                <Tooltip title={ convertirLetraMayus(a?.name) }>
                    <IconButton aria-label="read" onClick={ buttons[i]?.action }>
                        { buttons[i]?.icon }
                    </IconButton>
                </Tooltip>
            ))}
        </>
    );
}